import { useMemo } from "react";

export function useEventRating(rawRating: string) {
  const formattedRating = useMemo(() => {
    if (!rawRating) return "";

    const ratingMap: Record<string, string> = {
      GP: "General Patronage",
      PG: "Parental Guidance",
    };

    return ratingMap[rawRating.toUpperCase()] || rawRating;
  }, [rawRating]);

  return formattedRating;
}
